<!--PAGE-TOP-->
<app-header></app-header>
<!--/PAGE-TOP-->
<div class="i-page-content" style="background-color: #f8fafc">
  <div class="container pb-5">
    <iframe
      src="https://mysmithapp.lomatech.io/app/2a-via-boletos-private/page1-66c5435cd3ab9b501c5b42c1?embed=true"
      width="100%"
      height="600rem"
      [frameBorder]="0"></iframe>
  </div>
</div>
